import { ServiceStatus } from '../types';

/**
 * Customer-facing service status options for the public form.
 * Internal-only statuses (pre_delivery_inspection, used_preparation) are intentionally excluded.
 */
export const PUBLIC_STATUS_OPTIONS: { value: ServiceStatus; label: string }[] = [
  { value: 'maintenance', label: 'My equipment needs standard maintenance' },
  { value: 'repair', label: 'My equipment is not working and needs a repair' },
  { value: 'repair_maintenance', label: 'My equipment needs a repair and standard maintenance' },
  { value: 'inspection', label: 'My equipment needs an inspection' },
  { value: 'warranty', label: 'My equipment needs work that should be covered under warranty' },
  { value: 'in_field_optimization', label: 'My equipment needs in-field optimization' },
  { value: 'seasonal_preparation', label: 'My equipment needs seasonal preparation' },
];

/** Format a service status for display */
export function formatServiceStatus(status: ServiceStatus | string | null | undefined): string {
  if (!status) return 'N/A';
  const labels: Record<string, string> = {
    maintenance: 'Standard Maintenance',
    repair: 'Repair (Not Working)',
    repair_maintenance: 'Repair & Maintenance',
    inspection: 'Inspection',
    warranty: 'Warranty Work',
    in_field_optimization: 'In-Field Optimization',
    seasonal_preparation: 'Seasonal Preparation',
    pre_delivery_inspection: 'Pre-Delivery Inspection',
    used_preparation: 'Used Preparation',
  };
  return labels[status] ?? 'Unknown';
}
